import { render, staticRenderFns } from "./vehicleCard.vue?vue&type=template&id=527bfd92&scoped=true"
import script from "./vehicleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicleCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./vehicleCard.vue?vue&type=style&index=0&id=527bfd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bfd92",
  null
  
)

export default component.exports